// extracted by LIB_CSS_EXTRACT_LOADER
import "./pagination_module.css"
export default {"root":"root-PZ8BdD","content":"content-u_dlqe","item":"item-tPcmlz","link":"link-Pr6dma","previous":"previous-XBD3gG","next":"next-Kkf3jc","ellipsis":"ellipsis-ao182p","srOnly":"srOnly-HC5ql9"};